<template>
  <div class="wrapper">

    <v-sidebar activeNavItem="asset"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'Assets'" v-bind:path="'/asset'"></v-navbar>

      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12" v-if="loading">
              <p class="text-center">Loading...</p>
            </div>
            <div class="col-md-12" v-if="!loading && rows.length === 0">
              <p class="text-center">You don't currently have any assets added. Please click one of the Add buttons to get started.</p>
              <p class="text-center">
                <button class="btn btn-success btn-wd" v-on:click="addTractor()"><i class="fa fa-plus"></i> Add a Tractor</button>
                <button class="btn btn-success btn-wd" v-on:click="addTrailer()"><i class="fa fa-plus"></i> Add a Trailer</button>
              </p>
            </div>
            <div class="col-md-12" v-show="!loading && rows.length !== 0">
              <div class="card data-tables">
                <div class="card-body table-no-bordered dataTable dtr-inline table-full-width">
                  <div class="toolbar">
                    <!-- Here you can write extra buttons/actions for the toolbar -->
                  </div>
                  <div class="fresh-datatables">
                    <table id="datatables_assets" class="table table-condensed" cellspacing="0" width="100%" style="width:100%">
                      <thead>
                        <tr>
                          <th>Make</th>
                          <th>Model</th>
                          <th>Asset ID</th>
                          <th>Type</th>
                          <th class=" text-right">Actions</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="!loading && rows.length !== 0">
            <div class="col-12 text-right">
              <button class="btn btn-success btn-wd" v-on:click="addTractor()"><i class="fa fa-plus"></i> Add a Tractor</button>
              <button class="btn btn-success btn-wd" v-on:click="addTrailer()"><i class="fa fa-plus"></i> Add a Trailer</button>
            </div>
          </div>
        </div>
      </div>

      <v-footer></v-footer>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import router from '../../router'
import apiService from '../../services/api.service'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'

import { checkResponseErrors } from '../../utils/http'

export default {
  name: 'AssetView',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer
  },
  data: () => ({
    rows: [],
    loading: true
  }),
  async mounted() {
    // builds a table row from an asset
    const buildRow = (src) => {
      const isCreator = src.createdby == localStorage.getItem('local_id')

      return {
        id: src._id,
        make: src.make || "",
        model: src.model || "",
        assetId: src.assetId || "",
        type: src.type || "",
        actions: isCreator? `
          <a class="btn btn-link btn-info" onclick="editAsset('${src._id}', '${src.type}')"><i class="fa fa-fw fa-pencil"></i></a>
          <a class="btn btn-link btn-danger" onclick="deleteAsset('${src._id}', this)"><i class="fa fa-fw fa-trash"></i></a>
        ` : `
          <a class="btn btn-link btn-info" onclick="detailAsset('${src._id}', '${src.type}')"><i class="fa fa-fw fa-eye"></i></a>
        `
      }
    };

    // empties the rows array to force empty status
    window.emptyTable = () => {
      this.rows = [];
    }

    // fetches rows from server and draws the datatable
    try {
      const resp = await apiService.get('/asset/list/');
      if(await checkResponseErrors(resp)) return;
      const body = resp.data;
      
      if(body.Result && body.Result.length) {
        this.rows = body.Result.map(buildRow);
        initDataTable(this.rows);
      }

      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }

  }, // end mounted
  methods: {
    addTractor: () => router.push("/asset/tractor/add"),
    addTrailer: () => router.push("/asset/trailer/add")
  }
}

const initDataTable = (rows) => {
  window.dataTable = $('#datatables_assets').DataTable({
    "data": rows,
    "columns": [
      { "data": "make" },
      { "data": "model" },
      { "data": "assetId" },
      { "data": "type" },
      { "data": "actions", "className": 'text-right' },
    ],
    "order": [[ 4, "desc" ]],
    "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
    ],
    stateSave: false,
    retrieve: true,
    responsive: {
        details: false
    },
    language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
    }
  });
}

// deletes an asset
window.deleteAsset = async (id, button) => {
  if(!id) return;

  if(!confirm("Are you sure you want to delete this Asset?")) return;

  try {
    const resp = await apiService.delete('/kong/api/v1/asset/', {
      data: { id }
    });
    if(await checkResponseErrors(resp)) return;
  } catch (error) {
    Vue.toasted.error(error, { duration: 3500 });
    return;
  }

  Vue.toasted.success("Successfully Deleted Asset", { duration: 3500 });

  // removes from datatable and if the tables is empty forces the vue empty state
  dataTable.row($(button).parents('tr')).remove();
  if(dataTable.rows().count() === 0) emptyTable();
  dataTable.draw();
}

// edits an asset
window.editAsset = (id, type) => {
  if(id && (type === "Tractor" || type === "Trailer")) {
    router.push(`/asset/${type.toLowerCase()}/edit/${id}`);
  }
}

// show details of an asset
window.detailAsset = (id, type) => {
  if(id && (type === "Tractor" || type === "Trailer")) {
    router.push(`/asset/${type.toLowerCase()}/details/${id}`);
  }
}

</script>



// WEBPACK FOOTER //
// AssetView.vue?216a5f64